module.exports = __webpack_public_path__ + "img/hot-nft-bg.061fca34.png";